module.exports = __webpack_public_path__ + "img/img_logo_zhangjiakou.fb3c07ed.png";